export default __webpack_public_path__ + "images/icons/search-85953110fde4e2689bd29eea38cbc452.svg";